// Live Worker endpoints
// workers.dev URLs are always available; custom subdomains set via dashboard
export const WORKERS = {
  edgeApi: 'https://edge-api.shruti.workers.dev',
  kvDemo: 'https://kv-demo.shruti.workers.dev',
  d1Demo: 'https://d1-demo.shruti.workers.dev',
  r2Demo: 'https://r2-demo.shruti.workers.dev',
  aiDemo: 'https://ai-demo.shruti.workers.dev',
  securityDemo: 'https://security-demo.shruti.workers.dev',
} as const;

// Maturity Level apps — shruti-techlab.com custom subdomains
export const MATURITY_LEVELS = {
  l1: 'https://l1.shruti-techlab.com',
  l2: 'https://l2.shruti-techlab.com',
  l3: 'https://l3.shruti-techlab.com',
  l4: 'https://l4.shruti-techlab.com',
  l5: 'https://l5.shruti-techlab.com',
} as const;
